// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2olSY","box":"WorkspacesBox_box__pYpaV","node":"WorkspacesBox_node__36cfC"};